import React from 'react';
import TranslatedText from 'components/i18n/TranslatedText';
import { GDPR_ID } from 'global-ids';
import { MESSAGE } from 'injection-classes';
import { Transition } from 'react-transition-group';

import { getAdminBarWidth } from 'services/admin/selectors';
import { isMobileLayout as getIsMobileLayout } from 'services/device';
import { GDPRAccepted } from 'services/modals';
import { getSidebarWidth } from 'services/user-layout/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { AcceptButton, ArrowIcon, ButtonContainer, Container, StyledModalWindow, TextWrapper } from './styles';

function GDPRModal() {
  const dispatch = useDispatch();
  const adminbarWidth = useSelector(getAdminBarWidth);
  const isMobileLayout = useSelector(getIsMobileLayout);
  const sidebarWidth = useSelector(getSidebarWidth);

  const handleAccept = () => {
    setTimeout(() => {
      dispatch(GDPRAccepted());
    }, 500);
  };

  return (
    <StyledModalWindow
      adminbarWidth={adminbarWidth}
      sidebarWidth={sidebarWidth}
    >
      <Transition in={true} timeout={0}>
        {(state) => (
          <Container id={GDPR_ID} state={state}>
            <TranslatedText
              component={TextWrapper}
              componentProps={{
                className: MESSAGE,
              }}
              stringKey="GDPR_PROMPT"
            />
            <ButtonContainer>
              {!isMobileLayout && <ArrowIcon />}
              <AcceptButton onClick={handleAccept} />
            </ButtonContainer>
          </Container>
        )}
      </Transition>
    </StyledModalWindow>
  );
}

export default GDPRModal;
